import React from 'react';

const Passions = props => {
    return (
        <div className="scroll_y fixedheight">
            <h1>Be the change you want to see in the world.</h1>
            <ul>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Photography</h3>
                    <p>Write up on Photography</p>
                    <p>Write up on how I have been involved with Photography.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
            </ul>

        </div>
    )
}

export default Passions;